import { AxiosInstance } from 'axios';

import { APIManagerConfig } from '../apiManager';
import { FarmerLocation } from '../../../store/entities/locations/locations.types';

const LocationServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => ({
  getLocations: (): Promise<any> => {
    return HTTPBase.get(`farm/${config.farmId}/ingredientlocations`).then((res) => res.data);
  },
  createLocation: (payload: Partial<FarmerLocation>) => {
    return HTTPBase.post(`farm/${config.farmId}/ingredientlocations`, payload).then((res) => res.data);
  },
  editLocation: (id: string, payload: Partial<FarmerLocation>) => {
    return HTTPBase.patch(`farm/${config.farmId}/ingredientlocations/${id}`, payload).then((res) => res.data);
  },
  deleteLocation: (id: string) => {
    return HTTPBase.delete(`farm/${config.farmId}/ingredientlocations/${id}`).then((res) => res.data);
  },
});

export default LocationServiceFactory;
